import styled from 'styled-components';

const LegendSwatch = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 4px;
  background-color: ${({ color }) => color || '#dedede'};
`;

export default LegendSwatch;
